import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {StockInTransitReportModel} from "./stock-in-transit-report.model";

@Component({
    selector: "wbo-stock-in-transit-report",
    templateUrl: "./stock-in-transit-report.component.html",
    providers: [provideReportModel(StockInTransitReportModel)]
})
export class StockInTransitReportComponent extends AbstractReportPage {
    constructor(public model: StockInTransitReportModel) {
        super();
    }
}
